
import React, { useState, useEffect, useRef } from 'react';
import { Helmet } from "react-helmet";
import Tabs from "components/Sections/pricingpagtab/pricingtab";
import Freepricingcard from "components/Sections/pricingpagtab/freepricingcard";
import Faqs from "components/Sections/pricingpagtab/faqaccordian";
import JoinNetwork from "components/Sections/mobileappdownload/mobileappdownload";

import Dropdownpricing from "components/Sections/pricingpagtab/dropdownpricingcard/dropdownpricing"


import qrterapartner from "./images/terapartner.png";
import qrteraclients from "./images/teraclients.png";
import qeteraclinicians from "./images/teraclinician.png";

import "./pricing.css";
const pricing: React.FC = () => {
  const cardData = [
    {
      svg: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="90"
          height="90"
          viewBox="0 0 90 90"
          fill="none"
        >
          <circle cx="39" cy="61" r="29" fill="#EDD696" />
          <path
            d="M39.1354 47.2317C35.6146 50.6171 31.0104 52.6484 26 52.6484C20.9896 52.6484 16.3854 50.6171 12.8646 47.2317C5.28125 50.0754 0 57.3879 0 65.9192V72.9609C0 74.1796 0.94792 75.1275 2.16667 75.1275H49.8333C51.0521 75.1275 52 74.1796 52 72.9609V65.9192C52 57.3879 46.5833 50.0754 39.1354 47.2317Z"
            fill="#111827"
          />
          <path
            d="M10.6976 32.065C10.6976 41.138 17.6038 48.5859 25.9997 48.5859C34.3955 48.5859 41.3018 41.138 41.3018 32.065C41.3018 31.2525 41.3018 30.3046 41.1663 29.4921C43.6038 22.315 42.3851 9.17962 37.7809 11.2109C33.7184 12.9713 11.5101 7.28378 12.7288 16.7629C7.44759 16.8984 10.2913 27.19 10.833 29.4921C10.833 30.3046 10.6976 31.1171 10.6976 32.065ZM15.4372 32.4713C15.9788 32.4713 16.5205 32.065 16.3851 31.5234C16.1143 29.0859 15.5726 22.8567 17.7393 23.3984C20.4476 24.0754 23.4268 24.8879 25.9997 24.8879C28.5726 24.8879 31.5518 24.0754 34.2601 23.3984C36.4268 22.8567 35.8851 28.9504 35.6143 31.5234C35.4788 32.065 36.0205 32.6067 36.5622 32.4713L37.5101 32.3359C37.3747 39.2421 32.2288 44.6588 25.9997 44.6588C19.7705 44.6588 14.7601 39.1067 14.4893 32.3359L15.4372 32.4713Z"
            fill="#111827"
          />
        </svg>
      ),
      mainHeading: "Bridging Manpower Gaps",
      subHeading:
        "Connects professionalss, medical organizations, and clients PAN India, addressing staff shortages",
    },

    {
      svg: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="90"
          height="90"
          viewBox="0 0 90 90"
          fill="none"
        >
          <g clip-path="url(#clip0_336_130)">
            <circle cx="39" cy="61.1548" r="29" fill="#EDD696" />
            <path
              d="M40.2845 38.1221C40.4846 37.9219 40.6348 37.7218 40.8349 37.5216L42.5364 38.6225L41.4355 40.324L51.6943 46.0289C52.445 46.5294 53.3457 46.6795 54.1965 46.4793C55.0472 46.2791 55.7978 45.7787 56.2983 45.0281C56.7987 44.2774 56.9488 43.3766 56.7487 42.5259C56.5485 41.6752 56.0481 40.9245 55.2974 40.4241L45.6891 33.7684L44.7383 35.2697L42.9868 34.1687C43.0869 34.0186 43.1369 33.8184 43.237 33.6683C44.5381 30.6156 44.7884 27.3128 44.1378 24.2101C43.2871 20.3068 40.935 16.7537 37.382 14.4517C33.8789 12.1998 29.7254 11.4992 25.6719 12.3499C21.6184 13.2507 18.1654 15.6527 15.9135 19.1558C11.3095 26.362 13.4113 35.9703 20.6175 40.5742C24.1205 42.8262 28.2741 43.5268 32.3276 42.676C35.3802 42.0255 38.1827 40.4241 40.2845 38.1221ZM23.1697 36.6208C18.1654 33.4181 16.7141 26.7623 19.9169 21.758C21.5183 19.2559 23.9704 17.6545 26.6727 17.054C29.3751 16.4534 32.2776 16.9038 34.7797 18.5052C37.2819 20.1066 38.8833 22.5587 39.4838 25.261C40.0843 27.9634 39.6339 30.8659 38.0325 33.368C34.8298 38.3223 28.174 39.7735 23.1697 36.6208Z"
              fill="#111827"
            />
            <path
              d="M56.899 59.9409C56.5987 58.0893 55.3977 56.4879 53.6962 55.6372C48.0914 52.8347 35.8808 48.7312 35.8808 48.7312H34.8299L31.4771 53.185L34.6298 74.9038H57.9999C57.9999 74.9038 57.8498 65.4957 56.899 59.9409Z"
              fill="#111827"
            />
            <path
              d="M22.1191 48.7312C22.1191 48.7312 9.8585 52.8347 4.30371 55.6372C2.60224 56.4879 1.40121 58.0893 1.10095 59.9409C0.15013 65.5457 0 74.9538 0 74.9538H23.4202L26.4728 53.185L23.1199 48.7312H22.1191Z"
              fill="#111827"
            />
          </g>
          <defs>
            <clipPath id="clip0_336_130">
              <rect width="90" height="90" fill="white" />
            </clipPath>
          </defs>
        </svg>
      ),
      mainHeading: "Personalised Recruitment",
      subHeading:
        "Revolutionary ATS and 1:1 recruiter services, making hiring efficient and tailored to specific medical needs.",
    },

    {
      svg: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="90"
          height="90"
          viewBox="0 0 90 90"
          fill="none"
        >
          <circle cx="39" cy="61" r="29" fill="#EDD696" />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M42.7732 62.4133H18.278V65.2642H42.7732V62.4133ZM40.9844 67.2638H20.0668V69.7868H40.9844V67.266V67.2638ZM24.48 71.7865V72.2501C24.4822 72.9785 24.7724 73.6764 25.2873 74.1916C25.8021 74.7068 26.4997 74.9974 27.228 75H33.8239C34.5517 74.9972 35.2488 74.7068 35.7634 74.1921C36.278 73.6774 36.5684 72.9801 36.5712 72.2523V71.7886L24.48 71.7865ZM33.4442 44.0987H35.5204C35.9312 44.0988 36.3328 43.9771 36.6744 43.7489C37.0161 43.5207 37.2824 43.1963 37.4397 42.8167C37.5969 42.4372 37.6381 42.0194 37.558 41.6165C37.4779 41.2135 37.2801 40.8433 36.9896 40.5527C36.6991 40.2622 36.329 40.0644 35.9261 39.9842C35.5231 39.9041 35.1055 39.9453 34.726 40.1026C34.3465 40.2599 34.0221 40.5263 33.794 40.868C33.5658 41.2096 33.4441 41.6113 33.4442 42.0222V44.0987ZM27.5529 44.0987V42.0222C27.5529 41.6115 27.4312 41.2101 27.203 40.8686C26.9749 40.5271 26.6507 40.261 26.2713 40.1038C25.8919 39.9467 25.4745 39.9056 25.0718 39.9857C24.6691 40.0658 24.2991 40.2636 24.0088 40.554C23.7184 40.8444 23.5207 41.2143 23.4406 41.6171C23.3605 42.0199 23.4016 42.4374 23.5587 42.8168C23.7159 43.1963 23.982 43.5206 24.3234 43.7487C24.6648 43.9769 25.0662 44.0987 25.4768 44.0987H27.5529ZM31.4442 60.4158V46.0983H29.553V60.4158H31.4442ZM27.5529 60.4158H20.2759C20.2013 60.3071 20.137 60.1916 20.0839 60.0709C19.9781 59.8332 19.9178 59.5778 19.9061 59.3179C19.8661 58.2621 19.6301 57.2231 19.2101 56.2537C18.7786 55.2812 18.1731 54.3958 17.4233 53.6411C14.8997 51.0658 13.1925 47.8026 12.5158 44.2608C11.8391 40.7189 12.223 37.0561 13.6194 33.7316C15.0159 30.4072 17.3626 27.5691 20.3654 25.5733C23.3681 23.5774 26.8932 22.5128 30.4986 22.5128C34.1039 22.5128 37.629 23.5774 40.6318 25.5733C43.6346 27.5691 45.9813 30.4072 47.3777 33.7316C48.7741 37.0561 49.1581 40.7189 48.4814 44.2608C47.8047 47.8026 46.0974 51.0658 43.5738 53.6411C42.8241 54.3958 42.2186 55.2812 41.7871 56.2537C41.3671 57.2231 41.131 58.2621 41.091 59.3179C41.0722 59.7112 40.9439 60.0915 40.7206 60.4158H33.4442V46.0983H35.5204C36.3264 46.0982 37.1142 45.859 37.7843 45.411C38.4545 44.9631 38.9767 44.3264 39.2851 43.5816C39.5934 42.8368 39.674 42.0172 39.5167 41.2266C39.3593 40.4359 38.9711 39.7097 38.4012 39.1397C37.8312 38.5698 37.105 38.1816 36.3145 38.0244C35.5239 37.8672 34.7045 37.9479 33.9599 38.2565C33.2152 38.565 32.5788 39.0874 32.131 39.7577C31.6832 40.428 31.4442 41.2161 31.4442 42.0222V44.0987H29.553V42.0222C29.5531 41.2159 29.3141 40.4276 28.8663 39.7571C28.4185 39.0866 27.782 38.5639 27.0372 38.2552C26.2924 37.9466 25.4728 37.8657 24.682 38.023C23.8913 38.1802 23.1649 38.5684 22.5948 39.1385C22.0247 39.7087 21.6364 40.4351 21.479 41.2259C21.3217 42.0167 21.4024 42.8365 21.7109 43.5815C22.0194 44.3265 22.5418 44.9632 23.2121 45.4112C23.8825 45.8592 24.6706 46.0983 25.4768 46.0983H27.5529V60.4158ZM29.4989 11.9998C29.4989 11.7347 29.6042 11.4803 29.7917 11.2928C29.9792 11.1053 30.2335 11 30.4986 11C30.7637 11 31.018 11.1053 31.2054 11.2928C31.3929 11.4803 31.4982 11.7347 31.4982 11.9998V16.2146C31.4982 16.4797 31.3929 16.7341 31.2054 16.9216C31.018 17.1091 30.7637 17.2144 30.4986 17.2144C30.2335 17.2144 29.9792 17.1091 29.7917 16.9216C29.6042 16.7341 29.4989 16.4797 29.4989 16.2146V11.9998ZM14.8993 16.445C14.7678 16.216 14.7326 15.9442 14.8014 15.6893C14.8703 15.4343 15.0376 15.2172 15.2665 15.0857C15.4955 14.9541 15.7673 14.9189 16.0221 14.9878C16.277 15.0567 16.4941 15.224 16.6256 15.453L18.733 19.1067C18.7981 19.22 18.8403 19.3451 18.8571 19.4748C18.8739 19.6045 18.865 19.7362 18.8309 19.8624C18.7968 19.9886 18.7381 20.1069 18.6583 20.2104C18.5785 20.314 18.4791 20.4008 18.3658 20.466C18.2524 20.5311 18.1274 20.5733 17.9977 20.5901C17.8681 20.6068 17.7364 20.5979 17.6102 20.5638C17.484 20.5297 17.3657 20.4711 17.2622 20.3913C17.1586 20.3115 17.0718 20.212 17.0067 20.0987L14.8993 16.445ZM4.47609 27.6016C4.24716 27.4696 4.08006 27.252 4.01152 26.9968C3.94298 26.7415 3.97864 26.4695 4.11063 26.2405C4.24263 26.0116 4.46016 25.8444 4.71537 25.7759C4.97058 25.7073 5.24256 25.743 5.47148 25.875L9.12103 27.982C9.34995 28.1141 9.51706 28.3316 9.5856 28.5869C9.65413 28.8421 9.61848 29.1142 9.48648 29.3431C9.35449 29.5721 9.13696 29.7392 8.88175 29.8078C8.62654 29.8763 8.35456 29.8406 8.12564 29.7086L4.47609 27.6016ZM1.02704 42.4766C0.893472 42.4802 0.760544 42.4569 0.636102 42.4083C0.51166 42.3596 0.398226 42.2865 0.302495 42.1933C0.206763 42.1001 0.130675 41.9886 0.078721 41.8655C0.026767 41.7424 0 41.6101 0 41.4764C0 41.3428 0.026767 41.2105 0.078721 41.0874C0.130675 40.9643 0.206763 40.8528 0.302495 40.7596C0.398226 40.6664 0.51166 40.5933 0.636102 40.5446C0.760544 40.4959 0.893472 40.4727 1.02704 40.4763H5.24112C5.50172 40.4832 5.74932 40.5916 5.93119 40.7785C6.11306 40.9653 6.21483 41.2157 6.21483 41.4764C6.21483 41.7372 6.11306 41.9876 5.93119 42.1744C5.74932 42.3612 5.50172 42.4697 5.24112 42.4766H1.02704ZM5.47148 57.08C5.24256 57.212 4.97058 57.2477 4.71537 57.1791C4.46016 57.1106 4.24263 56.9435 4.11063 56.7145C3.97864 56.4855 3.94298 56.2135 4.01152 55.9583C4.08006 55.703 4.24716 55.4854 4.47609 55.3534L8.12564 53.2464C8.23899 53.181 8.3641 53.1386 8.49383 53.1216C8.62357 53.1046 8.75538 53.1133 8.88175 53.1473C9.00811 53.1812 9.12656 53.2397 9.23032 53.3194C9.33408 53.3992 9.42112 53.4985 9.48648 53.6119C9.55184 53.7253 9.59423 53.8504 9.61124 53.9802C9.62825 54.1099 9.61953 54.2418 9.5856 54.3681C9.55166 54.4945 9.49317 54.613 9.41346 54.7168C9.33375 54.8206 9.23438 54.9076 9.12103 54.973L5.47148 57.08ZM56.5211 55.3534C56.6344 55.4188 56.7338 55.5059 56.8135 55.6096C56.8932 55.7134 56.9517 55.8319 56.9856 55.9583C57.0196 56.0846 57.0283 56.2165 57.0113 56.3462C56.9943 56.476 56.9519 56.6011 56.8865 56.7145C56.8212 56.8279 56.7341 56.9272 56.6304 57.007C56.5266 57.0867 56.4082 57.1452 56.2818 57.1791C56.1554 57.2131 56.0236 57.2218 55.8939 57.2048C55.7641 57.1878 55.639 57.1454 55.5257 57.08L51.8761 54.973C51.6472 54.841 51.4801 54.6234 51.4116 54.3681C51.343 54.1129 51.3787 53.8409 51.5107 53.6119C51.6427 53.3829 51.8602 53.2158 52.1154 53.1473C52.3706 53.0787 52.6426 53.1144 52.8715 53.2464L56.5211 55.3513V55.3534ZM59.973 40.4784C60.1065 40.4748 60.2395 40.4981 60.3639 40.5467C60.4883 40.5954 60.6018 40.6685 60.6975 40.7617C60.7932 40.855 60.8693 40.9664 60.9213 41.0895C60.9732 41.2127 61 41.3449 61 41.4786C61 41.6122 60.9732 41.7445 60.9213 41.8676C60.8693 41.9907 60.7932 42.1022 60.6975 42.1954C60.6018 42.2887 60.4883 42.3618 60.3639 42.4104C60.2395 42.4591 60.1065 42.4823 59.973 42.4788H55.756C55.4954 42.4718 55.2478 42.3634 55.066 42.1766C54.8841 41.9898 54.7823 41.7393 54.7823 41.4786C54.7823 41.2178 54.8841 40.9674 55.066 40.7806C55.2478 40.5938 55.4954 40.4853 55.756 40.4784H59.973ZM55.5257 25.875C55.7546 25.743 56.0266 25.7073 56.2818 25.7759C56.537 25.8444 56.7545 26.0116 56.8865 26.2405C57.0185 26.4695 57.0542 26.7415 56.9856 26.9968C56.9171 27.252 56.75 27.4696 56.5211 27.6016L52.8715 29.7086C52.7582 29.774 52.6331 29.8164 52.5033 29.8334C52.3736 29.8504 52.2418 29.8417 52.1154 29.8078C51.989 29.7738 51.8706 29.7153 51.7668 29.6356C51.6631 29.5559 51.576 29.4565 51.5107 29.3431C51.4453 29.2297 51.4029 29.1046 51.3859 28.9749C51.3689 28.8451 51.3776 28.7133 51.4116 28.5869C51.4455 28.4605 51.504 28.342 51.5837 28.2383C51.6634 28.1345 51.7628 28.0474 51.8761 27.982L55.5257 25.875ZM44.3716 15.453C44.5031 15.224 44.7202 15.0567 44.975 14.9878C45.2299 14.9189 45.5017 14.9541 45.7306 15.0857C45.9595 15.2172 46.1268 15.4343 46.1957 15.6893C46.2646 15.9442 46.2294 16.216 46.0979 16.445L43.9905 20.0951C43.9286 20.2141 43.8433 20.3193 43.7397 20.4045C43.6362 20.4897 43.5165 20.5531 43.3878 20.5909C43.2592 20.6287 43.1242 20.6401 42.991 20.6244C42.8579 20.6087 42.7292 20.5663 42.6128 20.4997C42.4965 20.433 42.3948 20.3436 42.3138 20.2367C42.2329 20.1297 42.1744 20.0076 42.1418 19.8775C42.1092 19.7474 42.1033 19.612 42.1243 19.4796C42.1453 19.3471 42.1929 19.2203 42.2642 19.1067L44.3716 15.453Z"
            fill="#111827"
          />
        </svg>
      ),
      mainHeading: "Skill-Based Networking",
      subHeading:
        "A healthcare-focused hub connecting individuals and organisations, fostering skill-aligned connections",
    },

    {
      svg: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="90"
          height="90"
          viewBox="0 0 90 90"
          fill="none"
        >
          <circle cx="42" cy="61" r="29" fill="#EDD696" />
          <path
            d="M51.32 26.6212L55.7 27.6912C55.78 27.7112 55.85 27.7212 55.93 27.7212C56.19 27.7212 56.44 27.6112 56.63 27.4212L63.74 19.7212C64 19.4512 64.07 19.0512 63.92 18.7012C63.78 18.3612 63.44 18.1312 63.07 18.1212L57.16 17.9412L56.88 11.9012C56.86 11.5412 56.63 11.2012 56.29 11.0712C55.95 10.9312 55.55 11.0012 55.28 11.2512L47.6 18.3712C47.34 18.6112 47.24 18.9612 47.31 19.2912L48.38 23.6712C48.34 23.7012 48.3 23.7312 48.26 23.7612L47.12 24.9012C42.12 20.5812 35.62 17.9612 28.51 17.9612C12.79 17.9712 0 30.7612 0 46.4912C0 62.2212 12.79 75.0012 28.51 75.0012C44.23 75.0012 57.02 62.2112 57.02 46.4912C57.02 39.3812 54.4 32.8812 50.08 27.8812L51.22 26.7412C51.26 26.7012 51.29 26.6612 51.32 26.6212ZM28.51 70.8112C15.1 70.8112 4.19 59.9012 4.19 46.4912C4.19 33.0812 15.1 22.1612 28.51 22.1612C34.46 22.1612 39.92 24.3112 44.15 27.8812L41.54 30.4912C37.98 27.5912 33.45 25.8412 28.51 25.8412C17.13 25.8412 7.87 35.1012 7.87 46.4812C7.87 57.8612 17.13 67.1212 28.51 67.1212C39.89 67.1212 49.15 57.8612 49.15 46.4812C49.15 41.5412 47.41 37.0012 44.5 33.4512L47.11 30.8412C50.67 35.0712 52.83 40.5312 52.83 46.4812C52.84 59.9012 41.93 70.8112 28.51 70.8112ZM27.03 45.0012C26.63 45.4012 26.42 45.9212 26.42 46.4812C26.42 47.0412 26.64 47.5712 27.03 47.9612C27.43 48.3612 27.95 48.5712 28.51 48.5712C29.07 48.5712 29.6 48.3512 29.99 47.9612L35.47 42.4812C36.15 43.6612 36.54 45.0212 36.54 46.4812C36.54 50.9112 32.94 54.5112 28.51 54.5112C24.08 54.5112 20.48 50.9112 20.48 46.4812C20.48 42.0512 24.08 38.4512 28.51 38.4512C29.96 38.4512 31.33 38.8412 32.51 39.5212L27.03 45.0012ZM35.54 36.5012C33.55 35.1012 31.13 34.2612 28.52 34.2612C21.78 34.2612 16.3 39.7412 16.3 46.4812C16.3 53.2212 21.78 58.7012 28.52 58.7012C35.26 58.7012 40.74 53.2212 40.74 46.4812C40.74 43.8712 39.91 41.4512 38.5 39.4612L41.52 36.4412C43.67 39.2212 44.97 42.7012 44.97 46.4812C44.97 55.5512 37.59 62.9312 28.52 62.9312C19.45 62.9312 12.07 55.5512 12.07 46.4812C12.07 37.4112 19.45 30.0312 28.52 30.0312C32.3 30.0312 35.78 31.3312 38.56 33.4812L35.54 36.5012Z"
            fill="#111827"
          />
        </svg>
      ),
      mainHeading: "Targeted Connectivity",
      subHeading:
        "Focused outreach, even in underserved areas, facilitating regional-level connections for holistic healthcare solutions.",
    },

    // Add more card data as needed
  ];

  const faqItems = [
    {
      heading:
        "1. Is there a trial period for the Premium Plan?",
      content: [
        "Yes, we offer a trial period for the Premium Plan for 90days, allowing users to experience features before committing.",
      ],
    },
    {
      heading: "2. Can I switch from the Free Plan to the Premium Plan at any time?",
      content: [
        "Yes, users have the flexibility to upgrade to the Premium Plan at any point.",
      ],
    },
    {
      heading: "3. Are there any limitations on the Free Plan?",
      content: [
        "There is no limitation; use it like a premium plan.",
      ],
    },
    {
      heading: "4. Can I cancel my subscription at any time?",
      content: [
        "No, you can't cancel existing subscription.",
      ],
    },

    {
      heading: "5. Do you store my credit card information?",
      content: [
        "No, we don't store your credit card information. Read our Privacy Policy to learn more..",
      ],
    },
    {
      heading: "6. Are there any hidden fees in the pricing models?",
      content: [
        "No, our pricing is transparent, and there are no hidden fees. Users pay only for the selected plan.",
      ],
    },
    // Add more FAQ items as needed
  ];
  const faqItemsForClinicians = [
    {
      heading:
        "1. Is it really free for professionalss to use the platform for a lifetime?",
      content: [
        "Yes, absolutely! Our platform is committed to providing professionals with free access throughout their entire professional journey.",
      ],
    },
    {
      heading: "2. Are there any hidden fees or charges associated with the lifetime free access?",
      content: [
        "No, there are no hidden fees or charges. Our lifetime free access for professionals is transparent, ensuring a cost-free experience.",
      ],
    },
    {
      heading: "3. What services are included in the free access for professionals?",
      content: [
        " Professionals have access to all platform features, like job search, CME updates, medical groups, and communities.",
      ],
    },
    {
      heading: "4. How can I find a job that matches my qualifications?",
      content: [
        "We are using a skill match algorithm to find the ideal job for the candidate profile. so that you may acquire jobs that match your capabilities.",
      ],
    },

    {
      heading: "5. Can I choose between freelance and full-time positions on the platform?",
      content: [
        " Absolutely! Our platform offers personalized recommendations according to individual specializations and requirements, allowing you to select either freelance or full-time positions.",
      ],
    },
    // Add more FAQ items as needed
  ];
  const dummyDatadrop1 = {
    dropdownOptions: ['Annually'],
    defaultOption:"Quarterly",
    optionData: {
    'Monthly': {
      price: "₹ 999 + GST",
      label: "Monthly",
      labeltwo: "Valid for 30 days",
      features: [
        "Unlimited Job Posting",
        "Unlimited Profiles*5/Day/Job",
        "Range of Medical Services",
        "Buy, Sell or Rent Medical Equipment",
        "Candidate Search & Notifications",
        "Applicant Tracking System",
        "Schedule Interviews",
      ],
      crownData: "pass",
    },
    'Quarterly': {
      price: "₹ 2,750 + GST",
      label: "Quarterly",
      labeltwo: "Valid for 90 days",
      features: [
        "Unlimited Job Posting",
        "Unlimited Profiles*5/Day/Job",
        "Range of Medical Services",
        "Buy, Sell or Rent Medical Equipment",
        "Candidate Search & Notifications",
        "Applicant Tracking System",
        "Schedule Interviews",
      ],
      crownData: "pass",
      recommendedBadgeData: "RECOMMENDED",
    },
    'Half Yearly': {
      price: "₹ 5,500 + GST",
      label: "Half Yearly",
      labeltwo: "Valid for 180 days",
      features: [
        "Unlimited Job Posting",
        "Unlimited Profiles*5/Day/Job",
        "Range of Medical Services",
        "Buy, Sell or Rent Medical Equipment",
        "Candidate Search & Notifications",
        "Applicant Tracking System",
        "Schedule Interviews",
      ],
      crownData: "pass",
    },
    'Annually': {
      price: "₹ 9,999 + GST",
      label: "Annually",
      labeltwo: "Valid for 365 days",
      features: [
        "Unlimited Job Posting",
        "Unlimited Profiles*5/Day/Job",
        "Range of Medical Services",
        "Buy, Sell or Rent Medical Equipment",
        "Candidate Search & Notifications",
        "Applicant Tracking System",
        "Schedule Interviews",
      ],
      buttonUrl: "#download-app-now",
      crownData: "pass",
    },
  },
  buttonUrl: '#download-app-now',
  };

  const dummyDatadrop2 = {
    dropdownOptions: ['Annually'],
    defaultOption:"Quarterly",
    optionData: {
    'Monthly': {
      price: "₹ 999 + GST",
      label: "Monthly",
      labeltwo: "Valid for 30 days",
      features: [
        "Unlimited Job Posting",
        "Unlimited Profiles*5/Day/Job",
        "Applicant Tracking System",
        "Candidate Search & Notifications",
        "Schedule Interviews",
      ],
      crownData: "pass",
    },
    'Quarterly': {
      price: "₹ 2,750 + GST",
      label: "Quarterly",
      labeltwo: "Valid for 90 days",
      features: [
        "Unlimited Job Posting",
        "Unlimited Profiles*5/Day/Job",
        "Applicant Tracking System",
        "Candidate Search & Notifications",
        "Schedule Interviews",
      ],
      crownData: "pass",
      recommendedBadgeData: "RECOMMENDED",
    },
    'Half Yearly': {
      price: "₹ 5,500 + GST",
      label: "Half Yearly",
      labeltwo: "Valid for 180 days",
      features: [
        "Unlimited Job Posting",
        "Unlimited Profiles*5/Day/Job",
        "Applicant Tracking System",
        "Candidate Search & Notifications",
        "Schedule Interviews",
      ],
      crownData: "pass",
    },
    'Annually': {
      price: "₹ 9,999 + GST",
      label: "Annually",
      labeltwo: "Valid for 365 days",
      features: [
        "Unlimited Job Posting",
        "Unlimited Profiles*5/Day/Job",
        "Applicant Tracking System",
        "Candidate Search & Notifications",
        "Schedule Interviews",
      ],
      buttonUrl: "#download-app-now-2",
      crownData: "pass",
    },
  },
  buttonUrl: '#download-app-now-2',
  };

  
  const dummyDatadrop = {
    dropdownOptions: ['Annually'],
    defaultOption:"Quarterly",
    optionData: {
    'Monthly': {
      price: "₹ 999 + GST",
      label: "Monthly",
      labeltwo: "Valid for 30 days",
      features: [
        "Unlimited Service Leads",
        "Profile Highlight",
        "Boost Service Leads",
        "Range of Medical Services",
        "Buy, Sell or Rent Medical Equipment",
        "Support Tickets on Priority",
      ],
      crownData: "pass",
    },
    'Quarterly': {
      price: "₹ 2,750 + GST",
      label: "Quarterly",
      labeltwo: "Valid for 90 days",
      features: [
        "Unlimited Service Leads",
        "Profile Highlight",
        "Boost Service Leads",
        "Range of Medical Services",
        "Buy, Sell or Rent Medical Equipment",
        "Support Tickets on Priority",
      ],
      crownData: "pass",
      recommendedBadgeData: "RECOMMENDED",
    },
    'Half Yearly': {
      price: "₹ 5,500 + GST",
      label: "Half Yearly",
      labeltwo: "Valid for 180 days",
      features: [
        "Unlimited Service Leads",
        "Profile Highlight",
        "Boost Service Leads",
        "Range of Medical Services",
        "Buy, Sell or Rent Medical Equipment",
        "Support Tickets on Priority",
      ],
      crownData: "pass",
    },
    'Annually': {
      price: "₹ 9,999 + GST",
      label: "Annually",
      labeltwo: "Valid for 365 days",
      features: [
        "Unlimited Service Leads",
        "Profile Highlight",
        "Boost Service Leads",
        "Range of Medical Services",
        "Buy, Sell or Rent Medical Equipment",
        "Support Tickets on Priority",
      ],
      buttonUrl: "#download-app-now-3",
      crownData: "pass",
    },
  },
  buttonUrl: '#download-app-now-3',
  };


  // for clients
  const data1 = {
    price: "₹ 0",
    label: "Free",
    labeltwo: "Valid for 90 days",
    features: [
      "Unlimited Job Posting",
      "Unlimited Profiles*5/Day/Job",
      "Range of Medical Services",
      "Buy, Sell or Rent Medical Equipment",    "Candidate Search & Notifications",
      "Applicant Tracking System",
 
      "Schedule Interviews",
    ],
    buttonUrl: "#download-app-now",
    scrollTarget:"download-app-now"
  };



  //for Recruitment Agency
  const data6 = {
    price: "₹ 0",
    label: "Free",
    labeltwo: "Valid for 90 days",
    features: [
      "Unlimited Job Posting",
      "Unlimited Profiles*5/Day/Job",
      "Applicant Tracking System",
      "Candidate Search & Notifications",
      "Schedule Interviews",
    ],
    buttonUrl: "#download-app-now-2",
    scrollTarget:"download-app-now-2"
  };



  //for partner
  const data11 = {
    price: "₹ 0",
    label: "Free",
    labeltwo: "Valid for 90 days",
    features: [
      "Unlimited Service Leads",
      "Profile Highlight",
      "Boost Service Leads",
      "Range of Medical Services",
      "Buy, Sell or Rent Medical Equipment",
      "Support Tickets on Priority",
    ],
    buttonUrl: "#download-app-now-3",
  };



  //for Clinician
  const data16 = {
    price: "₹ 0",
    label: "Free",
    labeltwo: "100% Free Forever",
    features: [
      "Fulltime Jobs",
      "Freelance/Nearby Jobs",
      "CME Updates",
      "Lifetime Portfolio",
      "Personalized Promotions",
    ],
    buttonUrl: "#download-app-now-4",
  };


  return (
    <div className="nc-PageHomeDemo3 relative">
      <Helmet>
        <title> Plans & Pricing - Tera Connects </title>

        <meta
          name="description"
          content="Explore Tera Connect's flexible pricing plans and find the perfect fit for your healthcare institution's needs."
        />
      </Helmet>

      <div className="service-pages-header aboutus-pages-header pricing">
        <div className="container flex items-center justify-center service-pages-header-inner">
          <div className="hero-inner">
            <h3 className="font-white regular text-center title-custom title-heading-banner montserrat ">
              
              <span className="font-sky-blue bolders">
                {" "}
                Exponential Growth
              </span>{" "}
              with <br/>Tera Connects : Tailored Pricing for Exceptional Value
            </h3>
            <h5 className="font-white regular text-center title-custom montserrat">
              Choose your path to premium services and unmatched benefits in the
              medical industry.
            </h5>
          </div>
        </div>
      </div>

      <Tabs
        tabData={[
          {
            tabName: "Tab1",
            buttonContent: "+ Client",
            content: (
              <div className="conent-tab-1">
                <div className="container freecards">
                  <Freepricingcard {...data1} />
                  <Dropdownpricing {...dummyDatadrop1}  />
                </div>
                <div id="download-app-now">
                  <JoinNetwork
                    heading="Join Our Network"
                    subheading="Unlock collaboration with Tera Client—connect with professionals and vendors for exceptional medical synergy across India."
                    googlePlayUrl="https://play.google.com/store/apps/details?id=com.teraplatforms.teraconnects"
                    appStoreUrl="https://apps.apple.com/in/app/tera-connects/id6448921572"
                    imageUrl={qrteraclients}
                  />
                </div>
                <div className="container">
                  <div className="sec-padding pricing-faqs">
                    <Faqs items={faqItems} />
                  </div>
                </div>
              </div>
            ),
          },
          {
            tabName: "Tab2",
            buttonContent: "+ Recruitment Agency",
            content: (
              <div className="conent-tab-1">
                <div className="container freecards">
                  <Freepricingcard {...data6} />
                  <Dropdownpricing {...dummyDatadrop2}  />
                </div>
          


<div id="download-app-now-2">
                  <JoinNetwork
                    heading="Join Our Network"
                    subheading="Join Tera Connects for a transformative journey where your agency can thrive, connect with top-notch talent, and shape the future of medical staffing."
                    googlePlayUrl="https://play.google.com/store/apps/details?id=com.teraplatforms.teraconnects"
                    appStoreUrl="https://apps.apple.com/in/app/tera-connects/id6448921572"
                    imageUrl={qrteraclients}
                  />
                </div>
                <div className="container">
                  <div className="sec-padding pricing-faqs">
                    <Faqs items={faqItems} />
                  </div>
                </div>
              </div>
            ),
          },
          {
            tabName: "Tab3",
            buttonContent: " + Partner",
            content: (
              <div className="conent-tab-1">
                <div className="container freecards">
                  <Freepricingcard {...data11} />
                  <Dropdownpricing {...dummyDatadrop}  />
                </div>
            
     

                <div id="download-app-now-3">
                  <JoinNetwork
                    heading="Join Our Network"
                    subheading="Unlock growth with Tera Partner—connecting providers and medical establishments nationwide for 10X business success."
                    googlePlayUrl="https://play.google.com/store/apps/details?id=com.teraplatforms.terapartner"
                    appStoreUrl="https://apps.apple.com/in/app/tera-partner-healthcare/id6453868120"
                    imageUrl={qrterapartner}
                  />
                </div>
                <div className="container">
                  <div className="sec-padding pricing-faqs">
                    <Faqs items={faqItems} />
                  </div>
                </div>

             
              </div>
            ),
          },
          {
            tabName: "Tab4",
            buttonContent: " + Professional",
            content: (
              <div className="conent-tab-1">
                <div className="container freecards">
                  <Freepricingcard {...data16} />
                </div>
        
          

                <div id="download-app-now-4">
                  <JoinNetwork
                    heading="Join Our Network"
                    subheading="Join MediProHub to stay updated on new trends, network with medical industry leaders, and find job opportunities."
                    googlePlayUrl="https://play.google.com/store/apps/details?id=com.teraplatforms.jobseeker"
                    appStoreUrl="https://apps.apple.com/in/app/tera-recruit-job-search/id1659265164 "
                    imageUrl={qeteraclinicians}
                  />
                </div>
                <div className="container">
                  <div className="sec-padding pricing-faqs">
                    <Faqs items={faqItemsForClinicians} />
                  </div>
                </div>
              </div>
            ),
          },
      
        ]}
      />
    </div>
  );
};

export default pricing;
